module.exports = __webpack_public_path__ + "img/galerie-28.838cb04e.jpg";